module.exports = __webpack_public_path__ + "static/media/ascorel.9e096ee4.jpg";